import React from 'react';
import PropTypes from 'prop-types';
import colors from 'customizations/js/color-variables';

export const IconSearch = ({ className, color, onClick }) => (
  <svg
    className={className}
    onClick={onClick}
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill={color}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.0354 7.50985C14.0354 10.4214 11.6752 12.7817 8.76361 12.7817C5.85207 12.7817 3.4918 10.4214 3.4918 7.50985C3.4918 4.59831 5.85207 2.23804 8.76361 2.23804C11.6752 2.23804 14.0354 4.59831 14.0354 7.50985ZM16.0354 7.50985C16.0354 11.526 12.7797 14.7817 8.76361 14.7817C7.23289 14.7817 5.81264 14.3087 4.64102 13.5009L1.74422 16.3977C1.35369 16.7883 0.720527 16.7883 0.330003 16.3977C-0.0605217 16.0072 -0.0605217 15.3741 0.330003 14.9835L3.16401 12.1495C2.11964 10.8905 1.4918 9.27349 1.4918 7.50985C1.4918 3.49374 4.7475 0.238037 8.76361 0.238037C12.7797 0.238037 16.0354 3.49374 16.0354 7.50985Z"
    />
  </svg>
);

IconSearch.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
};

IconSearch.defaultProps = {
  className: '',
  color: colors.gray20,
  onClick: () => {}
};
